import { domReady } from '../modules/utils.js';

class FileInput extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();

    this.input = this.querySelector('input');
    if (!this.input) {
      return;
    }

    this.input.dataset.defaultLabel = this.input.dataset.label;
    this.input.addEventListener('change', this.changeEventHandler);
  }

  disconnectedCallback() {
    if (this.input) {
      this.input.removeEventListener('change', this.changeEventHandler);
    }
  }

  changeEventHandler() {
    if (this.files.length > 0) {
      this.setAttribute('data-has-file', '');
      this.setAttribute('data-label', this.files[0].name);
    } else {
      this.removeAttribute('data-has-file');
      this.setAttribute('data-label', this.dataset.defaultLabel);
    }
  }
}

customElements.define('file-input', FileInput);
